/**
 * @file Dropdown Tabs.
 */

import modulo from 'just-modulo';

/**
 * Dropdown Tabs component.
 */
const vDropdownTabs = () => {
	const dropdownTabsAll = document.querySelectorAll('.v-dropdown-tabs');

	if (!dropdownTabsAll.length) {
		return;
	}

	[...dropdownTabsAll].forEach((dropdownTabs) => {
		if (dropdownTabs.classList.contains('v-facet-dropdown-wrap')) {
			return;
		}

		const trigger = dropdownTabs.querySelector('.v-dropdown-tabs__trigger');
		const triggerLabel = trigger.querySelector('.v-dropdown-tabs__trigger-label');
		const list = dropdownTabs.querySelector('.v-dropdown-tabs__list');
		const tabs = dropdownTabs.querySelectorAll('.v-dropdown-tabs__link');
		let currentFocusIndex = 0;
		let lastFocus = null;

		trigger.addEventListener('click', () => {
			const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
			if (lastFocus && lastFocus.closest('.v-dropdown-tabs') && !wasOpen) {
				lastFocus = null;
				return;
			}

			trigger.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
			if (!wasOpen) {
				tabs[0].focus();
				currentFocusIndex = 0;
			}
		});

		trigger.addEventListener('keydown', (e) => {
			if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
				e.preventDefault();
				trigger.setAttribute('aria-expanded', 'true');

				if (e.code === 'ArrowDown') {
					tabs[0].focus();
					currentFocusIndex = 0;
				} else {
					tabs[tabs.length - 1].focus();
					currentFocusIndex = tabs.length - 1;
				}
			}
		});

		list.addEventListener('keydown', (e) => {
			if (e.code === 'ArrowDown' || e.code === 'ArrowUp' || e.code === 'Escape' || e.code === 'Home' || e.code === 'End' || (e.key.match(/[a-zA-z]/) && e.key.length === 1)) {
				e.preventDefault();
			} else {
				return;
			}

			if (e.code === 'Escape') {
				trigger.setAttribute('aria-expanded', 'false');
				trigger.focus();
			}

			if (e.key.match(/[a-zA-z]/) && e.key.length === 1) {
				const matchingTabs = [...tabs].filter((tab) => (
					tab.innerText.trim().toLowerCase().startsWith(e.key.toLowerCase())
				));
				if (matchingTabs.length) {
					matchingTabs[0].focus();
					currentFocusIndex = [...tabs].indexOf(matchingTabs[0]);
				}
			}

			if (e.code === 'ArrowDown') {
				currentFocusIndex = modulo(currentFocusIndex + 1, tabs.length);
			} else if (e.code === 'ArrowUp') {
				currentFocusIndex = modulo(currentFocusIndex - 1, tabs.length);
			} else if (e.code === 'Home') {
				currentFocusIndex = 0;
			} else if (e.code === 'End') {
				currentFocusIndex = tabs.length - 1;
			}
			tabs[currentFocusIndex].focus();
		});

		list.addEventListener('focusout', () => {
			setTimeout(() => {
				if (!document.activeElement.closest('.v-dropdown-tabs__list')) {
					trigger.setAttribute('aria-expanded', 'false');
					lastFocus = document.activeElement;
				}
			}, 0);
		});

		/**
		 * Switch tab.
		 *
		 * @param {Element} tab - The tab to switch to.
		 */
		const switchTab = (tab) => {
			[...tabs].forEach((t) => { t.setAttribute('aria-selected', 'false'); t.setAttribute('tabindex', '-1'); });
			tab.setAttribute('aria-selected', 'true');
			tab.removeAttribute('tabindex');
			tab.focus();

			const switchEvent = new CustomEvent('v-tab-switch', { detail: { tab } });
			document.dispatchEvent(switchEvent);

			trigger.setAttribute('aria-expanded', 'false');
			triggerLabel.innerText = tab.innerText.trim();
		};

		[...tabs].forEach((tab) => {
			tab.addEventListener('click', () => {
				switchTab(tab);
			});
		});
	});
};

export default vDropdownTabs;
